import { ref } from "vue";

export const email = ref();
export const credits = ref();

export const hasSound = ref(true);
